export function transformFolderData(data) {
    const fileMap = {};

    function processNode(node, parentId) {
        const currentId = parentId === null ? 'root' : `node_${node.id}`;
        fileMap[currentId] = {
            id: currentId,
            name: parentId === null ? 'Home' : node.name,
            isDir: true,
            parentId: parentId,
            childrenIds: [],
        };

        if (node.sub_folders && node.sub_folders.length > 0) {
            node.sub_folders.forEach(child => {
                const childId = `node_${child.id}`;
                fileMap[currentId].childrenIds.push(childId);
                processNode(child, currentId);
            });
        }
    }

    data.forEach(node => processNode(node, null));
    return fileMap;
}

export function transformFileData(currentFileMap, currentFolderId, filesData) {
    const newMap = { ...currentFileMap };
    const currentFolder = { ...newMap[currentFolderId] };

    filesData.forEach(file => {
        const fileId = `file_${file.id}`;
        
        if (!newMap[fileId]) {
            newMap[fileId] = {
                id: fileId,
                name: file.file_name || 'Unnamed file',
                size: file.file_size || 0,
                parentId: currentFolderId,
                isDir: false,
                description: file.description || '',
                keywords: file.keywords || '',
                tags: file.tags || '',
            };
        }

        if (!currentFolder.childrenIds.includes(fileId)) {
            currentFolder.childrenIds = [...currentFolder.childrenIds, fileId];
        }
    });

    newMap[currentFolderId] = currentFolder;
    return newMap;
}

export function transformSearchFileData(filesData) {
    const newArray = [];

    filesData.forEach(file => {
        const fileId = `file_${file.id}`;
        newArray.push({
            id: fileId,
            name: file.file_name || 'Unnamed file',
            size: file.file_size || 0,
            isDir: false,
            description: file.description || '',
            keywords: file.keywords || '',
            tags: file.tags || '',
        })
    });

    return newArray;
}

export function transformSearchFolderData(foldersData) {
    const newArray = [];

    foldersData.forEach(folder => {
        newArray.push({
            id: `node_${folder.id}`,
            name: folder.name,
            isDir: true,
            childrenIds: folder.sub_folders || [],
        })
    });

    return newArray;
}
